import { createSlice, PayloadAction } from '@reduxjs/toolkit'

declare global {
  interface Window {
    process?: {
      env?: {
        REACT_APP_USE_STORED_STATE?: string
      }
    }
  }
}

window.process = {
  ...window.process,
}

interface UserData {
  user?: any
  roles?: any[]
  departments?: any[]
  [key: string]: any
}

export interface UserState {
  user?: any
  roles?: any[]
  departments?: any[]
  [key: string]: any
}

let storedState: UserState | undefined
if (import.meta.env.VITE_USE_STORED_STATE) {
  try {
    const fullState = window.localStorage.getItem('_state')
    if (fullState) {
      storedState = JSON.parse(fullState).user
    }
  } catch (e) {
    console.error('Unable to set initial state from local storage:', e)
  }
}

const initialState: UserState | null = storedState || {}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserData>) => {
      if (state === null) {
        return { ...action.payload }
      }
      return { ...state, ...action.payload }
    },
    unsetUser: () => {
      return null
    },
  },
})

export const { setUser, unsetUser } = userSlice.actions
export default userSlice.reducer